import { Component, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SnackbarComponent } from "./snackbar/snackbar.component";
import { FullscreenSpinner } from "./spinner/spinner";
import { DialogComponent } from "./modals/dialog/dialog.component";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    SnackbarComponent,
    DialogComponent,
    FullscreenSpinner,
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit, OnDestroy {
  readonly isMaintenanceMode = environment.maintenanceMode;
  readonly maintenanceTitle = environment.maintenanceTitle;
  readonly maintenanceMessage = environment.maintenanceMessage;
  readonly maintenanceEta = environment.maintenanceEta;
  isDarkMode = false;

  private readonly storageListener = (event: StorageEvent): void => {
    if (!event.key || event.key === "theme") {
      this.syncThemeMode();
    }
  };

  constructor() {}

  ngOnInit(): void {
    this.syncThemeMode();
    window.addEventListener("storage", this.storageListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener("storage", this.storageListener);
  }

  private syncThemeMode(): void {
    const savedThemeRaw = localStorage.getItem("theme") ?? "";
    const savedTheme = savedThemeRaw.replace(/"/g, "").trim().toLowerCase();

    if (savedTheme === "dark") {
      this.isDarkMode = true;
    } else if (savedTheme === "light") {
      this.isDarkMode = false;
    } else if (document.documentElement.classList.contains("dark")) {
      this.isDarkMode = true;
    } else {
      this.isDarkMode = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
    }

    // Keep global dark class aligned so any shared/global dark styles are consistent.
    document.documentElement.classList.toggle("dark", this.isDarkMode);
  }
}
